import React from 'react'
import { connect } from 'react-redux'
import { Intro } from 'components/Layout'

const FirstLoginIntro = ({ firstLogin, userName }) => {
	const welcomeMessage = userName ? `Hello, ${userName}!` : `Hello, there!`
	return (
		<Intro
			header={welcomeMessage}
			body={
				firstLogin
					? "Welcome to your Developer Console. We've got some tips ready to get you started."
					: "Welcome again. We've got some tips ready to get you started."
			}
		/>
	)
}
const mapStateToProps = (state, ownProps) => {
	return {
		userName: state.user.meta.name,
		firstLogin: state.user.firstLogin
	}
}

export default connect(mapStateToProps, null)(FirstLoginIntro)



// WEBPACK FOOTER //
// ./src/containers/Intros/FirstLoginIntro.js